import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header';
import { reportActions } from '../actions/reportActions';
import { downloadCSV } from '../lib/downloadToCsv';

export class Report extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: '',
            endDate: '',
            type: 'day',
            groupBy: 'subject'
        }
        this.submitSearch = this.submitSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.downloadSummary = this.downloadSummary.bind(this);
        this.downloadDetail = this.downloadDetail.bind(this);
    }
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }
    submitSearch() {
        if (this.state.fromDate == '' || this.state.endDate == '') {
            alert("From and end date are required fields.");
        } else {
            const params = { ...this.state };
            this.props.getReport(params);
        }
    }
    downloadSummary() {
        downloadCSV(this.props.data);
    }
    downloadDetail() {
        this.props.downloadDetail(this.props.filter);
    }
    render() {
        const { data, filter } = this.props;
        return (
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <Header></Header>
                        <div className="box box-default">
                            {/* <div className="box-header with-border">
                                <h3 className="box-title">Select2</h3>
                            </div> */}
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>From Date:</label>
                                            <div className="input-group date">
                                                <input type="date" className="form-control pull-right" value={this.state.fromDate} name="fromDate" onChange={this.handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>End Date:</label>
                                            <div className="input-group date">
                                                <input type="date" className="form-control pull-right" value={this.state.endDate} name="endDate" onChange={this.handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Type:</label>
                                            <select className="form-control" title="type" name="type" onChange={this.handleChange} value={this.state.type}>
                                                <option key="day" value="day">Day wise</option>
                                                <option key="total" value="total">Total</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Group By:</label>
                                            <select className="form-control" title="groupBy" name="groupBy" onChange={this.handleChange} value={this.state.groupBy}>
                                                <option key="subject" value="subject">Subject</option>
                                                <option key="exam" value="exam">Exam</option>
                                                <option key="userRating" value="userRating">User Rating</option>
                                                <option key="expertRating" value="expertRating">Expert Rating</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="box-footer">
                                <button type="submit" className="btn btn-primary" onClick={this.submitSearch}>Search</button>
                            </div>
                        </div>
                        {this.props.fetching ?
                            <div className="row"><div className="col-md-5"></div>  <div className="loader col-md-2"></div></div> :
                            <div>
                                {data && data.length ?
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="box">
                                                <div className="box-header">
                                                    <h3 className="box-title">Report :</h3>
                                                </div>

                                                <div className="box-body table-responsive no-padding scroll-table">
                                                    <table className="table table-hover">
                                                        <tbody><tr>
                                                            <th>Date</th>
                                                            <th>Page Launched</th>
                                                            <th>{filter && filter.groupBy ? filter.groupBy : 'Group By'}</th>
                                                        </tr>
                                                            {data.map((result, index) => (
                                                                <tr key={index}>
                                                                    <td>{result.date ? result.date : filter.fromDate + 'to ' + filter.endDate}</td>
                                                                    <td>{result.count}</td>
                                                                    <td>{result.groupBy}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody></table>
                                                </div>
                                                <div className="box-footer">
                                                    <button type="submit" className="btn btn-primary margin-r-5" onClick={this.downloadDetail}> Download Detail</button>
                                                    <button type="submit" className="btn btn-primary" onClick={this.downloadSummary}> Download Summary</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ''} </div>}
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { data, filter } = state.report;
    const { fetching } = state.notification;
    return {
        data,
        filter,
        fetching
    };
};

const actionCreators = {
    getReport: reportActions.getReport,
    downloadDetail: reportActions.downloadDetail
}

export default connect(mapStateToProps, actionCreators)(Report);
